// extracted by mini-css-extract-plugin
export var rateTable = "_42-0";